import React, { useState } from "react";
import { Box } from "@mui/material";
import { FileModel } from "../../models/models";
import noImage from "../../../shared/assets/images/noImage.png";
import { dt } from "../../themes/redesignTokens";

interface ImageListProps {
  images: FileModel[] | null | undefined;
}

const SHOW_IMAGE_INTERVAL = 1500;

const ImageList = ({ images }: ImageListProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeInterval, setTimeInterval] = useState<NodeJS.Timeout | null>(null);

  const isImageList = !!images && images?.length > 1;

  const startTimer = () => {
    if (isImageList && !timeInterval) {
      if (timeInterval) {
        clearInterval(timeInterval);
      }

      const interval = setInterval(() => {
        setCurrentIndex((prev) => {
          return isImageList && images[prev + 1] ? prev + 1 : 0;
        });
      }, SHOW_IMAGE_INTERVAL);

      setTimeInterval(interval);
    }
  };

  const handleStartCarousel = () => {
    startTimer();
  };

  const handleEndCarousel = () => {
    if (isImageList && timeInterval) {
      if (timeInterval) {
        clearInterval(timeInterval);
      }
      setTimeInterval(null);
      setCurrentIndex(0);
    }
  };
  return (
    <>
      {images && (
        <Box
          className="flex"
          sx={{ width: "128px", aspectRatio: "1", position: "relative", cursor: "pointer" }}
          onMouseEnter={handleStartCarousel}
          onMouseLeave={handleEndCarousel}
        >
          {images.length < 1 && <img src={noImage} className="w-full h-full rounded-lg" />}
          {images.map((image, i) => (
            <Box key={i} className="flex grow h-full">
              {i === currentIndex && (
                <img src={image.content} alt="" className="w-full h-full rounded-lg object-cover" />
              )}
            </Box>
          ))}

          <Box className="flex w-full z-10 absolute bottom-2 left-0 gap-1 px-2">
            {images.map(
              (image, i) =>
                images.length > 1 && (
                  <Box
                    key={image.name ? image.name + i : 0}
                    className="grow"
                    sx={{ background: i === currentIndex ? dt.blue : "#fff", height: "4px", borderRadius: "4px" }}
                  />
                )
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default ImageList;